import { Auth } from 'aws-amplify'

export async function isInRole(
  role: string,
  roles?: Array<string>
): Promise<boolean> {
  return await Auth.currentSession()
    .then(session => session.getAccessToken().decodePayload())
    .then(payload => payload['cognito:groups'] || [])
    .then(
      groups =>
        groups.includes(role) || roles?.some(group => groups.includes(group))
    )
}
